import { MessageService } from './../../../services/message.service';
import { VisitorCardService } from './../../../services/visitor-card.service';
import { EntitlementService } from './../../../services/entitlement.service';
import { CustomerAccount } from './../../../data/CustomerAccount';
import { Component, OnInit, Input } from '@angular/core';
import { VisitorCard } from 'src/app/data/VisitorCard';

@Component({
  selector: 'app-visitor-card-account-details',
  templateUrl: './visitor-card-account-details.component.html',
  styleUrls: ['./visitor-card-account-details.component.css']
})
export class VisitorCardAccountDetailsComponent implements OnInit {
  @Input() visitorCard: VisitorCard;
  @Input() customerAccount: CustomerAccount;

  displayDrown = false;
  currentCardStatus = '';
  processing = false;

  constructor(
    private entitlementService: EntitlementService,
    private visitorCardService: VisitorCardService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.currentCardStatus = this.visitorCard.status;
    this.displayDrown =
      (this.currentCardStatus === 'ACTIVE' ||
        this.currentCardStatus === 'PENDACTIVE') &&
      this.hasEntitlement('VISITORS_ACCOUNTS_UPDATE');
  }

  save() {
    const that = this;
    this.visitorCardService
      .updateSelectedVisitorCardStatus(this.currentCardStatus)
      .subscribe(() => {
        that.visitorCard.status = that.currentCardStatus;
        this.messageService.success('Saved Successfully');
        that.currentCardStatus = '';
      });
  }

  hasEntitlement(entitlement: string) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  isEMV(closedLoopPan) {
    return closedLoopPan != null;
  }
}
